import { useNavigate } from 'react-router-dom'
import { FleetMap, type MapMarker } from '../components/FleetMap'
import { Badge } from '../components/ui/Badge'
import type { EstadoValidacion } from '../api/cargas'

// TODO: real API call — GET /cargas?desde=hoy&pageSize=100
const MOCK_MARKERS: Array<MapMarker & { estado: EstadoValidacion; vehiculo: string; litros: number }> = [
  { id: 'c1',  lat: -17.771, lng: -63.193, color: '#10B981', popup: 'TH-EX 02 · 280 L',  estado: 'VALIDA',             vehiculo: 'TH-EX 02', litros: 280 },
  { id: 'c2',  lat: -17.783, lng: -63.180, color: '#F59E0B', popup: 'TH-VO 01 · 420 L',  estado: 'OUTLIER',            vehiculo: 'TH-VO 01', litros: 420 },
  { id: 'c3',  lat: -17.760, lng: -63.202, color: '#10B981', popup: 'TH-MN 05 · 190 L',  estado: 'VALIDA',             vehiculo: 'TH-MN 05', litros: 190 },
  { id: 'c4',  lat: -17.795, lng: -63.171, color: '#F59E0B', popup: 'TH-EX 04 · 310 L',  estado: 'PENDIENTE_REVISION', vehiculo: 'TH-EX 04', litros: 310 },
  { id: 'c5',  lat: -17.775, lng: -63.165, color: '#10B981', popup: 'TH-VO 03 · 450 L',  estado: 'VALIDA',             vehiculo: 'TH-VO 03', litros: 450 },
  { id: 'c6',  lat: -17.752, lng: -63.212, color: '#EF4444', popup: 'TH-MN 02 · 200 L',  estado: 'RECHAZADA',          vehiculo: 'TH-MN 02', litros: 200 },
  { id: 'c7',  lat: -17.790, lng: -63.195, color: '#10B981', popup: 'TH-EX 06 · 320 L',  estado: 'VALIDA',             vehiculo: 'TH-EX 06', litros: 320 },
  { id: 'c8',  lat: -17.765, lng: -63.175, color: '#F59E0B', popup: 'TH-VO 05 · 390 L',  estado: 'OUTLIER',            vehiculo: 'TH-VO 05', litros: 390 },
  { id: 'c9',  lat: -17.780, lng: -63.188, color: '#10B981', popup: 'TH-MN 07 · 175 L',  estado: 'VALIDA',             vehiculo: 'TH-MN 07', litros: 175 },
  { id: 'c10', lat: -17.758, lng: -63.197, color: '#10B981', popup: 'TH-EX 08 · 295 L',  estado: 'VALIDA',             vehiculo: 'TH-EX 08', litros: 295 },
]

const COLOR_BY_ESTADO: Record<EstadoValidacion, string> = {
  VALIDA:             '#10B981',
  OUTLIER:            '#F59E0B',
  PENDIENTE_REVISION: '#F59E0B',
  RECHAZADA:          '#EF4444',
}

export default function Mapa() {
  const navigate = useNavigate()

  const markers: MapMarker[] = MOCK_MARKERS.map((m) => ({
    id: m.id,
    lat: m.lat,
    lng: m.lng,
    color: COLOR_BY_ESTADO[m.estado],
    popup: m.popup,
    onClick: () => navigate(`/cargas/${m.id}`),
  }))

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100">Mapa de cargas</h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">
            {MOCK_MARKERS.length} cargas geolocalizadas · Santa Cruz, Bolivia
          </p>
        </div>
        {/* Leyenda */}
        <div className="flex items-center gap-4 text-xs text-slate-600 dark:text-slate-400">
          {(['VALIDA', 'OUTLIER', 'RECHAZADA'] as EstadoValidacion[]).map((e) => (
            <span key={e} className="flex items-center gap-1.5">
              <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: COLOR_BY_ESTADO[e] }} />
              {e === 'VALIDA' ? 'Válida' : e === 'OUTLIER' ? 'Outlier' : 'Rechazada'}
            </span>
          ))}
        </div>
      </div>

      <FleetMap
        markers={markers}
        center={[-63.18, -17.78]}
        zoom={12}
        height="calc(100vh - 220px)"
        className="shadow-sm border border-slate-200 dark:border-slate-700"
      />

      {/* Lista lateral compacta bajo el mapa */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
        {MOCK_MARKERS.map((m) => (
          <button
            key={m.id}
            onClick={() => navigate(`/cargas/${m.id}`)}
            className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-2.5 text-left hover:border-primary transition-colors"
          >
            <p className="text-xs font-semibold text-slate-800 dark:text-slate-200">{m.vehiculo}</p>
            <p className="text-xs text-slate-500">{m.litros} L</p>
            <Badge estado={m.estado} className="mt-1" />
          </button>
        ))}
      </div>
    </div>
  )
}
